import axios from 'axios'

let allCountries: unknown = null

class CountriesAPI {
  static currentCountry: any = null;

  static async fetchAllCountries() {
    if (allCountries) {
      return allCountries
    }
    // eslint-disable-next-line no-return-assign
    return (allCountries = (await axios.get('/data/countries.json')).data)
  }

  static async getCountry(iso2code: string) {
    const countries = await CountriesAPI.fetchAllCountries()
    return countries.find((country: any) => country.alpha2Code === iso2code)
  }

  static async getCurrentCountry() {
    if (this.currentCountry) {
      return this.currentCountry
    }
    const [status, alpha2Code, alpha3Code, name] = (await axios.get('https://ip2c.org/s')).data.split(';')
    // eslint-disable-next-line no-return-assign
    if (status === '1') return (this.currentCountry = { alpha2Code, alpha3Code, name })
    throw name
  }
}

export default CountriesAPI
